import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { listUsageAdjustments, createUsageAdjustment, decideUsageAdjustment } from '../api/usageAdjustments'
import type { CreateUsageAdjustmentInput, DecideUsageAdjustmentInput } from '../types/usageAdjustment.types'

export function useUsageAdjustments(accountId: string | null) {
  return useQuery({
    queryKey: ['usage-adjustments', accountId],
    queryFn: () => listUsageAdjustments(accountId!),
    enabled: !!accountId,
  })
}

export function useCreateUsageAdjustment(accountId: string | null, requestedBy: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateUsageAdjustmentInput) => createUsageAdjustment(accountId!, input, requestedBy),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['usage-adjustments', accountId] })
    },
  })
}

export function useDecideUsageAdjustment(accountId: string | null) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: DecideUsageAdjustmentInput }) =>
      decideUsageAdjustment(accountId!, id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['usage-adjustments', accountId] })
    },
  })
}
